import { Globe } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";

export default function LanguageSwitcher({ id = "language-switcher" }) {
  const { lang, setLang, languages, t } = useLanguage();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={id}
          className="flex items-center gap-2 rounded-full border-2 border-slate-900 bg-white px-3 py-1.5 text-sm font-semibold text-slate-900 transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-[3px_3px_0px_0px_rgba(15,23,42,1)]"
        >
          <Globe className="h-4 w-4" strokeWidth={2} />
          <span className="uppercase">{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="border-2 border-slate-900 bg-white shadow-[4px_4px_0px_0px_rgba(15,23,42,1)]">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`cursor-pointer font-medium ${lang === l.code ? "bg-sky-100 text-slate-900" : ""}`}
          >
            <span className="mr-2 inline-flex w-8 justify-center rounded border border-slate-900 bg-sky-100 px-1 text-xs font-bold">{l.flag}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
